import { Product, ProductTaxTypes } from './product.interface';

export interface Package {
  id?: number;
  name: string;
  name_public: string;
  description: string;
  price: number;
  tax: ProductTaxTypes;
  products?: Product[];
}

export interface PackageIdsSync {
  package_ids: number[];
}
